<p-toast></p-toast>
<p-dialog header="{{ 'DEVICES_SCREEN' | translate}}" [(visible)]="statusModal" [breakpoints]="{'960px': '75vw', '640px': '100vw'}"
    [style]="{width: '50%', height: '400px'}">

    <h5 class="cstF2">{{ 'ASSOCIATED_DEVICES' | translate}}
        <p-multiSelect (onChange)="actualizarSuscripcion()" [options]="suscriptions" [(ngModel)]="suscriptionsSelected"
            optionLabel="name" placeholder="{{ 'SELECT_DEVICE' | translate}}"
            selectedItemsLabel="{0} {{ 'SELECTED_DEVICES' | translate}}" [style]="{'min-width':'100%'}">
        </p-multiSelect>
    </h5>
</p-dialog>

<p-dialog header="{{ 'CHANGE_USER_ROL_TITLE' | translate}}" [(visible)]="roleModal" [breakpoints]="{'960px': '75vw', '640px': '100vw'}"
    [style]="{width: '50%', height: '300px'}">
    <h5 class="cstF2">{{ 'CURRENT_ROLE' | translate}}
        <span class="custRole">{{currentRole}}</span>
    </h5>
    <p-dropdown placeholder="{{ 'SELECT_ROLE' | translate}}" (onChange)="obtenerValorSeleccionado(rol)" [options]="roles"
        [(ngModel)]="rol" [itemSize]="4" [filter]="false" optionLabel="name">
    </p-dropdown>
</p-dialog>

<p-dialog header="Asignar chats del dispositivo {{nameToken}} al usuario" [(visible)]="usersModal" [style]="{width: '50%'}">
    <span style="margin-bottom: 3px;">Asigne los chats a otro usuario para poder actualizar el estatus:</span>
    <p-dropdown (onChange)="reasignarChats()" placeholder="Seleccionar usuario"
      [options]="catalogosUsers" optionValue="id" optionLabel="name" [appendTo]="'body'" [(ngModel)]="selectedUserId">
    </p-dropdown>
    <div style="display: flex; align-items: center; justify-content: center;" *ngIf="loadingApi" class="loading-indicator">
        <p-progressSpinner [style]="{'width':'40px', 'height':'40px'}"></p-progressSpinner>
        <p [style]="{'width':'40px', 'height':'40px'}"> Cargando... </p>
    </div>
  </p-dialog>

<div class="card">
    <p-table #dt1 [value]="users" dataKey="id" [rows]="10" [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10,25,50]" [loading]="loading" styleClass="p-datatable-gridlines" [paginator]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
        [currentPageReportTemplate]="translate.instant('ENTRIES', {first: '{first}', last: '{last}', totalRecords: '{totalRecords}'})"
        [globalFilterFields]="['nombre','correo','rol','estatus']">

        <ng-template pTemplate="caption">
            <div class="p-d-flex"></div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>
                    <!-- SE COMENTARON LOS FILTROS TEMPORALMENTE -->
                    <div class="p-d-flex p-jc-between p-ai-center">
                        {{ 'NAME_ACCOUNT' | translate}}
                        <!-- <p-columnFilter type="text" field="nombre" display="menu"></p-columnFilter> -->
                    </div>
                </th>
                <th>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        {{ 'MAIL_ACCOUNT' | translate}}
                        <!-- <p-columnFilter type="text" field="correo" display="menu"></p-columnFilter> -->
                    </div>
                </th>
                <th>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        {{ 'ROL_ACCOUNT' | translate}}
                        <!-- <p-columnFilter type="text" field="rol" display="menu"></p-columnFilter> -->
                    </div>
                </th>
                <th>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        {{ 'STATUS_ACCOUNT' | translate}}
                        <!-- <p-columnFilter field="estatus" matchMode="equals" display="menu">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                <p-dropdown [ngModel]="value" [options]="statuses" (onChange)="filter($event.value)"
                                    placeholder="Any">
                                    <ng-template let-option pTemplate="item">
                                        <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                    </ng-template>
                                </p-dropdown>
                            </ng-template>
                        </p-columnFilter> -->
                    </div>
                </th>
                <th style="width: 7rem"></th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-user>
            <tr>
                <td class="custText">
                    <span class="p-column-title ">Nombre</span> {{user.name + " " + user.lastName}}
                </td>
                <td class="taC">
                    <span class="p-column-title ">Correo</span><span class="custText">{{user.email}}</span>
                </td>
                <td class="taC">
                    <span class="p-column-title ">Rol</span><span class="custText">{{user.rol}}</span>
                </td>
                <td class="taC">
                    <p-inputSwitch [(ngModel)]="user.status" (click)="cambiarStatus(user.idUser, user)"></p-inputSwitch>
                </td>
                <td class="p-text-center">
                    <span>
                        <button type="button" pButton icon="pi pi-mobile" (click)="openStatusModel(user)"
                            class="p-button-text icnCust">
                        </button>
                    </span>
                    <span>
                        <button type="button" pButton icon="pi pi-user-edit" (click)="openRoleModel(user)"
                            class="p-button-text icnCust">
                        </button>
                    </span>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7">No se encontraron usuarios</td>
            </tr>
        </ng-template>
    </p-table>
</div>